var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarSharingafter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 988.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .carSharing_after_svg__cls-3{fill:#343a50}.carSharing_after_svg__cls-24,.carSharing_after_svg__cls-32,.carSharing_after_svg__cls-34,.carSharing_after_svg__cls-35,.carSharing_after_svg__cls-37,.carSharing_after_svg__cls-6{fill:#fff}.carSharing_after_svg__cls-6{opacity:.32}.carSharing_after_svg__cls-7{fill:#eb9a6b}.carSharing_after_svg__cls-16,.carSharing_after_svg__cls-23,.carSharing_after_svg__cls-26,.carSharing_after_svg__cls-27,.carSharing_after_svg__cls-28,.carSharing_after_svg__cls-29,.carSharing_after_svg__cls-30,.carSharing_after_svg__cls-31,.carSharing_after_svg__cls-33,.carSharing_after_svg__cls-34,.carSharing_after_svg__cls-41,.carSharing_after_svg__cls-42,.carSharing_after_svg__cls-43,.carSharing_after_svg__cls-44,.carSharing_after_svg__cls-47,.carSharing_after_svg__cls-52,.carSharing_after_svg__cls-54,.carSharing_after_svg__cls-59,.carSharing_after_svg__cls-60{stroke:#343a50}.carSharing_after_svg__cls-16,.carSharing_after_svg__cls-23,.carSharing_after_svg__cls-26,.carSharing_after_svg__cls-27,.carSharing_after_svg__cls-28,.carSharing_after_svg__cls-29,.carSharing_after_svg__cls-30,.carSharing_after_svg__cls-31,.carSharing_after_svg__cls-33,.carSharing_after_svg__cls-34,.carSharing_after_svg__cls-41,.carSharing_after_svg__cls-42,.carSharing_after_svg__cls-47,.carSharing_after_svg__cls-59,.carSharing_after_svg__cls-60{stroke-miterlimit:10}.carSharing_after_svg__cls-16{stroke-width:2px}.carSharing_after_svg__cls-43,.carSharing_after_svg__cls-44,.carSharing_after_svg__cls-52,.carSharing_after_svg__cls-54{stroke-linejoin:round}.carSharing_after_svg__cls-43,.carSharing_after_svg__cls-44,.carSharing_after_svg__cls-52,.carSharing_after_svg__cls-54,.carSharing_after_svg__cls-60{stroke-linecap:round}.carSharing_after_svg__cls-26,.carSharing_after_svg__cls-27,.carSharing_after_svg__cls-28,.carSharing_after_svg__cls-29,.carSharing_after_svg__cls-30,.carSharing_after_svg__cls-31,.carSharing_after_svg__cls-33,.carSharing_after_svg__cls-34{stroke-width:3.15px}.carSharing_after_svg__cls-16{fill:#89bb21}.carSharing_after_svg__cls-14,.carSharing_after_svg__cls-17{mix-blend-mode:multiply}.carSharing_after_svg__cls-15,.carSharing_after_svg__cls-17{fill:#dedede}.carSharing_after_svg__cls-18{fill:#6b472d}.carSharing_after_svg__cls-23{fill:#065494;stroke-width:4.1px}.carSharing_after_svg__cls-24{font-size:91.55px}.carSharing_after_svg__cls-24,.carSharing_after_svg__cls-37{font-family:Lato-Regular,Lato}.carSharing_after_svg__cls-26,.carSharing_after_svg__cls-36{fill:#4a998a}.carSharing_after_svg__cls-27{fill:#525254}.carSharing_after_svg__cls-28{fill:#404040}.carSharing_after_svg__cls-29{fill:#46bea9}.carSharing_after_svg__cls-30,.carSharing_after_svg__cls-60{fill:none}.carSharing_after_svg__cls-31{fill:#a8a9ad}.carSharing_after_svg__cls-32{opacity:.17}.carSharing_after_svg__cls-33{fill:#ef6767}.carSharing_after_svg__cls-37{font-size:16.79px}.carSharing_after_svg__cls-38{letter-spacing:-.03em}.carSharing_after_svg__cls-39{letter-spacing:0}.carSharing_after_svg__cls-40{letter-spacing:-.01em}.carSharing_after_svg__cls-41,.carSharing_after_svg__cls-42{fill:#303042;stroke-width:3.24px}.carSharing_after_svg__cls-42{fill:#353454}.carSharing_after_svg__cls-43,.carSharing_after_svg__cls-44{fill:#cca605;stroke-width:2px}.carSharing_after_svg__cls-44{fill:#f0c100}.carSharing_after_svg__cls-47,.carSharing_after_svg__cls-52{stroke-width:2.17px}.carSharing_after_svg__cls-47{fill:#ffaa86}.carSharing_after_svg__cls-52,.carSharing_after_svg__cls-54{fill:#ffccb5}.carSharing_after_svg__cls-54{stroke-width:1.44px}.carSharing_after_svg__cls-59{fill:#464655;stroke-width:.5px}.carSharing_after_svg__cls-60{stroke-width:1.16px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Free-Floating_Nachher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Boden"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-.98 989.07 -.98 912.13 -.96 712.92 1258.99 712.92 1258.99 989.07 -.98 989.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 713.91v274.18H0V713.91h1258m2-2H-1.95v278.15H1260V711.94z",
    className: "carSharing_after_svg__cls-3"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "1258 361.58 .02 361.35 0 -91.91 1257.99 -91.91 1258 361.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9bf5c",
    points: "-1 714.91 -.98 348.08 1257.72 348.08 1259.01 714.91 -1 714.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.72 349.08l1.28 364.83H0V349.08h1256.7m2-2H-2v368.83h1262v-2l-1.28-364.84v-2z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775.11 25.32c10.22-24 36.06-41.16 66.58-41.16 30.14 0 55.8 16.71 66.27 40.26a55.23 55.23 0 0113.49-1.85c27.55 0 49.85 19.9 49.85 44.43s-22.3 44.45-49.85 44.45H791.84C764.31 111.45 742 91.56 742 67c0-19.28 13.86-35.53 33.11-41.68zM234.59-13.85c6.08-14.3 21.47-24.51 39.64-24.51 17.95 0 33.22 10 39.46 24a32.42 32.42 0 018-1.11c16.39 0 29.68 11.85 29.68 26.46s-13.29 26.46-29.68 26.46h-77.14c-16.39 0-29.68-11.85-29.68-26.46 0-11.5 8.26-21.18 19.72-24.84zM560.7 10.81c-6.62-15.55-23.35-26.65-43.11-26.65-19.51 0-36.12 10.82-42.9 26.07A35.17 35.17 0 00466 9c-17.83 0-32.28 12.89-32.28 28.78S448.13 66.57 466 66.57h83.91c17.82 0 32.27-12.88 32.27-28.77-.04-12.49-9.02-23.01-21.48-26.99z",
    className: "carSharing_after_svg__cls-6"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: ".99 465.81 -1.01 88.11 458.49 87.51 458.49 465.81 .99 465.81",
    className: "carSharing_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.49 88.51v376.3H2L0 89.1l457.49-.59m2-2L-2 87.11l2 379.7h459.49V86.51z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 316.6,
    height: 378.3,
    x: 141.89,
    y: 87.51,
    fill: "#cc825c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.49 88.51v376.3h-314.6V88.51h314.6m2-2h-318.6v380.3h318.6V86.51z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 175.34,
    height: 285.34,
    x: 250.51,
    y: 117.21,
    fill: "#7fc3ca",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 338.18 259.875)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.86 402.59 328.86 268.75 250.5 268.75 250.5 250.11 328.86 250.11 328.86 117.19 347.51 117.19 347.51 250.11 425.87 250.11 425.87 268.75 347.51 268.75 347.51 402.59 328.86 402.59",
    className: "carSharing_after_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52 118.18V251.1h78.35v16.66h-78.35v133.83h-16.67V267.76h-78.36V251.1h78.36V118.18h16.67m2-2h-20.66v132.94h-78.35v20.63h78.35v133.83h20.65V269.75h78.35v-20.63h-78.35V116.2z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#823838",
    stroke: "#343a50",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-.9 -59.34 458.77 86.51 -.9 86.83 -.9 -59.34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Haus",
    stroke: "#343a50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8,
    height: 513.52,
    x: 1199.27,
    y: 75.93,
    fill: "#d9d9d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    strokeMiterlimit: 10,
    strokeWidth: 3.15,
    points: "1259.67 28.13 1259.67 -15.87 1258 -13.54 1199.04 76.29 1259.67 75.92 1259.67 28.13"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M485 570h-2.29c-13.93 0-24.83-7-24.83-16 0-7.06 7-13.15 17.1-15.26a12.26 12.26 0 01-3.76-8.53c0-7.14 7.07-13.27 17.43-15.32a10.61 10.61 0 01-.33-2.61c0-7.76 8.29-14.24 19.91-15.72 1-8.4 11.49-14.81 24.76-14.81a38.81 38.81 0 016.42.53c4.64-4.23 12.13-6.74 20.26-6.74a35.63 35.63 0 0112.9 2.32c4.22-3.66 10.79-6 17.91-6.38 4.62-4.37 12.22-7 20.5-7 13.14 0 23.94 6.64 24.78 15 8.12 1.37 14.68 5.37 17.28 10.51 11.6.1 21.33 5.22 23.85 12.42 11.5.27 21 5.47 23.35 12.69 9.79 2.29 16.3 8.27 16.3 15.08 0 3.62-1.79 7-5.1 9.79 7.76 2.8 12.62 8.08 12.62 14 0 7.33-7.65 13.72-18.6 15.53h-.12l-219.14.5H485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 466c12.84 0 23.26 6.48 23.26 14.48v.3c8.77 1.14 15.71 5.36 17.81 10.75h.69c11.72 0 21.38 5.4 23 12.42h.24c11.73 0 21.41 5.42 23 12.45 9.28 1.91 16 7.34 16 13.75 0 4.07-2.7 7.74-7 10.37 8.54 2.14 14.56 7.34 14.56 13.42 0 6.71-7.33 12.33-17.28 14l-219.07.5h-3.42c-12.85 0-23.26-6.48-23.26-14.48 0-7.12 8.27-13 19.15-14.24-3.61-2.55-5.81-5.89-5.81-9.55 0-6.86 7.67-12.59 18-14.09a9.43 9.43 0 01-.86-3.84c0-7.27 8.63-13.27 19.86-14.3v-.18c0-8 10.42-14.47 23.26-14.47a36.06 36.06 0 016.93.65c4.1-4.11 11.4-6.86 19.75-6.86a33.69 33.69 0 0113.23 2.58c3.9-3.81 10.57-6.4 18.25-6.67 4.09-4.16 11.43-6.94 19.83-6.94m0-3.15c-8.42 0-16.22 2.59-21.15 7-6.94.45-13.18 2.63-17.57 6.12a37.7 37.7 0 00-12.59-2.09c-8.18 0-15.79 2.46-20.74 6.64a40.23 40.23 0 00-5.94-.44c-13.46 0-24.27 6.4-26.13 15-11.8 1.87-20.12 8.82-20.12 17.12a11 11 0 00.09 1.4c-10.28 2.49-17.19 9-17.19 16.53a13.11 13.11 0 002.52 7.61c-9.47 2.71-15.86 9-15.86 16.18 0 9.89 11.6 17.63 26.41 17.63h3.56l218.94-.5h.51c11.73-1.94 19.92-9 19.92-17.09 0-6-4.31-11.33-11.35-14.54a13.6 13.6 0 003.82-9.25c0-7.36-6.63-13.8-16.68-16.41-2.88-7.19-12.21-12.34-23.46-12.89-3.17-7.09-12.67-12.09-24-12.44-2.93-5-9.07-8.77-16.82-10.31-1.71-8.71-12.6-15.22-26.18-15.22z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_after_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.85 560.6c0-7.12 8.27-13 19.15-14.24-3.61-2.55-5.81-5.88-5.81-9.55 0-6.86 7.67-12.59 18-14.08a9.51 9.51 0 01-.86-3.84c0-7.28 8.63-13.28 19.86-14.31v-.17c0-8 10.42-14.48 23.26-14.48a36.8 36.8 0 016.93.65c4.1-4.11 11.4-6.86 19.75-6.86a33.69 33.69 0 0113.23 2.58c3.9-3.81 10.57-6.4 18.25-6.67 4.09-4.16 11.43-6.94 19.83-6.94a34.74 34.74 0 0110.69 1.63c-3.77-4.93-11.79-8.32-21.13-8.32-8.4 0-15.74 2.78-19.83 6.94-7.68.27-14.35 2.86-18.25 6.67a33.69 33.69 0 00-13.21-2.61c-8.35 0-15.65 2.75-19.75 6.86a36.06 36.06 0 00-6.93-.65c-12.84 0-23.26 6.48-23.26 14.47v.18c-11.23 1-19.86 7-19.86 14.3a9.43 9.43 0 00.86 3.84c-10.29 1.5-18 7.23-18 14.09 0 3.66 2.2 7 5.81 9.55-10.88 1.21-19.15 7.12-19.15 14.24 0 5.59 5.11 10.44 12.57 12.85a10.15 10.15 0 01-2.15-6.13z",
    className: "carSharing_after_svg__cls-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1196.05,
    cy: 256.66,
    className: "carSharing_after_svg__cls-16",
    rx: 114.24,
    ry: 115.14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.66 258.86c0-63.59 51.15-115.14 114.24-115.14 2.61 0 5.2.1 7.77.27a114.16 114.16 0 00-23.62-2.47c-63.09 0-114.23 51.55-114.23 115.14 0 61 47 110.84 106.46 114.87-51.76-10.97-90.62-57.24-90.62-112.67z",
    className: "carSharing_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.82 593.65a5.53 5.53 0 01-4-1.7 5.33 5.33 0 01-1.47-4l18.24-267.79-20.72-20.93a1.63 1.63 0 01-.36-1.82 1.67 1.67 0 011.54-1 1.79 1.79 0 01.75.17l19.74 9.63 2.73-40.16.17-3.18a5.24 5.24 0 0110.46-.2l1.84 25.26 19.58-10.45h.16a3.77 3.77 0 01.57-.05 3.13 3.13 0 011.85 5.61l-20.41 14.86 18.32 290a5.35 5.35 0 01-1.39 4 5.53 5.53 0 01-4.06 1.77z",
    className: "carSharing_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.69 258.86a4.1 4.1 0 014.22 3.9l1.95 26.77 20.8-11.09a1.87 1.87 0 01.4 0 2.13 2.13 0 011.24 3.82l-20.84 15.16 18.36 290.51a4.41 4.41 0 01-4.45 4.76h-43.55a4.42 4.42 0 01-4.46-4.6l18.27-268.22-21-21.25a.69.69 0 01.47-1.17.73.73 0 01.31.07l21.08 10.28 2.83-41.64.17-3.2a4.12 4.12 0 014.24-4.06m0-2a6.12 6.12 0 00-6.24 6l-.16 3.19-2.64 38.65-18.4-9a2.76 2.76 0 00-1.19-.27 2.69 2.69 0 00-1.89 4.58l20.4 20.6-18.2 267.33a6.28 6.28 0 001.74 4.72 6.5 6.5 0 004.71 2h43.55a6.49 6.49 0 004.8-2.1 6.32 6.32 0 001.64-4.83l-18.28-289.37 20-14.52a4.13 4.13 0 00-2.42-7.43 4.76 4.76 0 00-.75.07l-.31.06-.28.14-18.09 9.65-1.72-23.7a6.1 6.1 0 00-6.22-5.76z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_after_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1209 291.74l22.87-12.19a2 2 0 00-2.23-1.11l-20.8 11.09zM1199.63 309.8l3-43.68.16-3.2a4.08 4.08 0 012.09-3.51 4.25 4.25 0 00-6.39 3.51l-.17 3.2-2.82 41.64zM1180.67 588.05l18.26-268.22-19.84-20.05-4.72-2.3a.68.68 0 00-.78 1.1l21 21.25-18.27 268.22a4.42 4.42 0 004.46 4.6h4.31a4.41 4.41 0 01-4.42-4.6z",
    className: "carSharing_after_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Baum-2",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 556.73,
    cy: 207.39,
    className: "carSharing_after_svg__cls-16",
    rx: 54.29,
    ry: 54.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 208.44c0-30.22 24.31-54.73 54.3-54.73 1.24 0 2.47 0 3.69.13a54.61 54.61 0 00-11.22-1.17c-30 0-54.3 24.5-54.3 54.72A54.56 54.56 0 00553 262a54.65 54.65 0 01-43-53.56z",
    className: "carSharing_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.49 368.08a3.15 3.15 0 01-2.28-1 3 3 0 01-.84-2.26l8.65-127-9.68-9.82a1.33 1.33 0 01.93-2.26 1.34 1.34 0 01.59.13l8.68 4.24 1.25-18.31.07-1.51a3 3 0 013-2.87 2.94 2.94 0 013 2.76l.82 11.21 8.67-4.62h.52a2 2 0 011.2 3.6l-9.48 6.9 8.69 137.53a3.09 3.09 0 01-.8 2.31 3.15 3.15 0 01-2.32 1z",
    className: "carSharing_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.88 208.44a2 2 0 012 1.85l.92 12.72 9.89-5.27h.19a1 1 0 01.59 1.81l-9.9 7.21 8.72 138.07a2.09 2.09 0 01-2.11 2.26h-20.7a2.09 2.09 0 01-2.12-2.18l8.68-127.49-10-10.09a.33.33 0 01.22-.56.4.4 0 01.15 0l10 4.89 1.35-19.79.07-1.52a2 2 0 012-1.93m0-2a4 4 0 00-4 3.82l-.08 1.52-1.15 16.8-7.3-3.56a2.32 2.32 0 00-2.67 3.72l9.36 9.46-8.62 126.58a4.12 4.12 0 001.11 3 4.19 4.19 0 003 1.28h20.7a4.15 4.15 0 003-1.34 4.07 4.07 0 001-3.1l-8.65-136.92 9-6.57a2.94 2.94 0 001-3.35 3 3 0 00-2.82-2 3.27 3.27 0 00-.54 0l-.31.06-.28.15-7.18 3.82-.7-9.65a4 4 0 00-4-3.71z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_after_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.89 224.07l10.87-5.8a1 1 0 00-1.06-.53l-9.89 5.26zM558.42 232.65l1.41-20.76.08-1.52a1.93 1.93 0 011-1.67 2 2 0 00-3 1.67l-.07 1.52-1.35 19.79zM549.41 364.9l8.68-127.49-9.43-9.52-2.24-1.1a.33.33 0 00-.37.53l10 10.09-8.68 127.49a2.09 2.09 0 002.12 2.18h2a2.1 2.1 0 01-2.08-2.18z",
    className: "carSharing_after_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Baum-3",
    "data-name": "Baum"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 954.67,
    cy: 221.23,
    className: "carSharing_after_svg__cls-16",
    rx: 63.28,
    ry: 63.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900.16 222.45c0-35.23 28.34-63.78 63.28-63.78 1.45 0 2.89.05 4.31.15a62.69 62.69 0 00-13.08-1.37c-34.95 0-63.28 28.56-63.28 63.78 0 33.77 26 61.4 59 63.63a63.69 63.69 0 01-50.23-62.41z",
    className: "carSharing_after_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.23 408.35a3.53 3.53 0 01-2.54-1.09 3.34 3.34 0 01-.93-2.51l10.09-148.15-11.34-11.45a1.38 1.38 0 011-2.35 1.43 1.43 0 01.61.14l10.31 5.06 1.47-21.59.09-1.76a3.35 3.35 0 016.69-.12l1 13.31 10.3-5.49h.16a1.81 1.81 0 01.4 0 2.18 2.18 0 011.29 3.91l-11.12 8.09 10.14 160.38a3.43 3.43 0 01-.89 2.57 3.54 3.54 0 01-2.58 1.13z",
    className: "carSharing_after_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.34 222.45a2.27 2.27 0 012.34 2.16l1.08 14.83 11.52-6.15h.22a1.18 1.18 0 01.69 2.11l-11.54 8.41 10.17 160.92a2.46 2.46 0 01-2.47 2.64h-24.12a2.45 2.45 0 01-2.47-2.55l10.12-148.58-11.66-11.77a.38.38 0 01.26-.65.33.33 0 01.17 0l11.68 5.7 1.57-23.07.09-1.78a2.28 2.28 0 012.35-2.24m0-2a4.26 4.26 0 00-4.35 4.14l-.09 1.77-1.36 20.08-9-4.4a2.38 2.38 0 00-3.24 1.23 2.41 2.41 0 00.51 2.59l11 11.12-10.05 147.7A4.39 4.39 0 00943 408a4.5 4.5 0 003.26 1.4h24.12a4.5 4.5 0 003.32-1.46 4.4 4.4 0 001.14-3.35l-10.1-159.78 10.63-7.81a3.18 3.18 0 00-1.91-5.7 3.77 3.77 0 00-.57 0l-.31.06-.28.15-8.81 4.7-.86-11.77a4.28 4.28 0 00-4.33-4z",
    className: "carSharing_after_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "carSharing_after_svg__cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M961.85 240.66l12.67-6.75a1.15 1.15 0 00-1.24-.62l-11.52 6.15zM956.64 250.66l1.65-24.19.09-1.78a2.26 2.26 0 011.15-1.94 2.36 2.36 0 00-3.54 1.94l-.09 1.78-1.56 23.07zM946.14 404.8l10.12-148.58-11-11.1-2.62-1.28a.38.38 0 00-.43.61l11.66 11.77-10.11 148.58a2.45 2.45 0 002.47 2.55h2.38a2.46 2.46 0 01-2.47-2.55z",
    className: "carSharing_after_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Haus-2",
    stroke: "#343a50",
    strokeWidth: 2,
    "data-name": "Haus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Fasade",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2ab80",
    points: "-.99 645.03 77.43 645.03 77.43 172.36 -.99 172.9 -.99 645.03"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.42,
    height: 132.91,
    x: -0.99,
    y: 512.12,
    fill: "#ca9072"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a04a48",
    strokeLinejoin: "round",
    points: "-.89 95.61 107.86 178.95 -.99 178.95 -.89 95.61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Schilder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.41,
    height: 229.7,
    x: 841.04,
    y: 494.2,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.68
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 796.95,
    y: 386.68,
    className: "carSharing_after_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-24",
    transform: "matrix(1.04 0 0 1 818.36 486.22)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 1223.78,
    y: 386.68,
    className: "carSharing_after_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-24",
    transform: "matrix(1.04 0 0 1 1244.89 486.26)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 4.41,
    height: 234.11,
    x: 414.2,
    y: 494.91,
    fill: "#828282",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 4.73
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: 370.11,
    y: 386.68,
    className: "carSharing_after_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-24",
    transform: "matrix(1.04 0 0 1 391.12 486.14)"
  }, "\r\n      P\r\n     "), /*#__PURE__*/React.createElement("rect", {
    width: 92.6,
    height: 138.94,
    x: -57.22,
    y: 386.68,
    className: "carSharing_after_svg__cls-23",
    rx: 20.59
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-24",
    transform: "matrix(1.04 0 0 1 -36.2 486.14)"
  }, "\r\n      P\r\n     ")), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M899.37 631.7L930 616.92l-25.48-24c-.54.26-37.09-7-37.62-6.77a23.52 23.52 0 00-3.62 2.14l-90.63-2.15-9.3 3.36c-.71-.34-2.12 2.16-2.83 1.81-.54-.25-.37 2.61-.91 2.35l-27.9 26.24 31.92 16.1c7.75-11.26 17.59-19 39.33-17.08h44.46c23.86.25 43.02 5.71 51.95 12.78z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.32 617.4h-53c-29.52 0-53.45 16.84-53.45 37.62l-26.78 4.69h216.55L911.77 655c0-20.76-23.93-37.6-53.45-37.6zm47.39 36.82H758.09v-.72c0-18.4 21.19-33.32 47.34-33.32h52.94c26.15 0 47.34 14.92 47.34 33.32z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.99,
    height: 21.06,
    x: 788.87,
    y: 646.02,
    className: "carSharing_after_svg__cls-27",
    transform: "rotate(-29.97 791.022 656.615)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 3.99,
    x: 797.79,
    y: 654.56,
    className: "carSharing_after_svg__cls-27",
    transform: "rotate(-60.02 808.35 656.557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.18 699.8a30.14 30.14 0 1130.14-30.14 30.17 30.17 0 01-30.14 30.14zm0-54.3a24.16 24.16 0 1024.16 24.16 24.19 24.19 0 00-24.16-24.16z",
    className: "carSharing_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 672.01,
    y: 796.46,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 939.25,
    y: 796.46,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.28 654.77c-2.3-4.11-5.71-6.08-8.6-7.69 0 0-9.43-5.27-27.83-1.81a4.86 4.86 0 00-2.49 1.13c-2.64 2.41-1.35 7.69-1.13 8.6 1.51 6.2 6.56 9.84 10.18 12.44a36.09 36.09 0 0010.64 5.2c3 .9 5.7 1.71 9.27 1.36 2.26-.22 8-.78 10.86-5.2 3.63-5.6-.26-12.88-.9-14.03zM947.29 656.72c2.3-4.12 5.7-6.08 8.59-7.69 0 0 9.43-5.28 27.83-1.81a4.86 4.86 0 012.49 1.13c2.64 2.4 1.35 7.68 1.13 8.59-1.51 6.21-6.56 9.84-10.18 12.45a36.13 36.13 0 01-10.63 5.2c-3 .89-5.7 1.71-9.28 1.36-2.26-.22-8-.79-10.86-5.21-3.63-5.59.26-12.87.91-14.02z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.24 667.83c0-3.75-53.76-6.8-120.08-6.8s-120.09 3.05-120.09 6.8l-46.2 27 333.33.66z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.65 697.74c-12.58-8.94-84.74-15.8-171.88-15.8-92 0-167.32 7.64-173.43 17.31a18.16 18.16 0 00-8 15.08v46.32h.06c2.38 9 83 16.22 182 16.22s179.63-7.23 182-16.22h.06v-46.32a18.14 18.14 0 00-10.81-16.59z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 830.33,
    x2: 830.32,
    y1: 612.03,
    y2: 624.58,
    className: "carSharing_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.51 761.16a8 8 0 00-3.07-6.27v5.76h-.06c-2.38 9-83 16.22-182 16.22s-179.62-7.23-182-16.22h-.06v-5.73a8 8 0 00-3 6.24V789a7.89 7.89 0 00.24 1.89 2.34 2.34 0 00-.24 1c0 11 82.88 19.83 185.11 19.83s185.12-8.88 185.12-19.83a2.34 2.34 0 00-.24-1 7.89 7.89 0 00.24-1.89z",
    className: "carSharing_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: 813.06,
    y: 619.98,
    className: "carSharing_after_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.03 661.14 944.64 664.5 938.36 626.03 915.13 600.87 895.91 587.97 851.28 584.66 764.36 589.15 742.06 604.26 722.75 631.88 717.03 661.14",
    className: "carSharing_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.4 582.49h-78.19a78.9 78.9 0 00-78.9 78.9v5.13h236v-5.13a78.89 78.89 0 00-78.91-78.9zm70 77.22H724.43v-1.51a69.89 69.89 0 0169.89-69.89h78.15a69.89 69.89 0 0169.89 69.89z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 656.75,
    y: 706.14,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 963.26,
    y: 705.82,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: 780.63,
    y: 739.56,
    className: "carSharing_after_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 708.52v7.61h-7.62v-7.61H826m.72-.73h-9.07v9.07h9.07v-9.07z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 820.39,
    y: 710.55,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.46 708.52v7.61h-7.62v-7.61h7.62m.72-.73h-9.06v9.07h9.06v-9.07z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 839.94,
    y: 710.55,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826 728v7.62h-7.62V728H826m.72-.72h-9.07v9.06h9.07v-9.04z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 820.39,
    y: 730.07,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.46 728v7.62h-7.62V728h7.62m.72-.72h-9.06v9.06h9.06v-9.04z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 839.9,
    y: 730.07,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.4 717.58v9h-9v-9h9m.72-.72h-10.44v10.44h10.44v-10.44z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 830.17,
    y: 720.32,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 830.15,
    y: 727.3,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 830.17,
    y: 713.34,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 823.17,
    y: 720.33,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 837.15,
    y: 720.32,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 820.39,
    y: 723.83,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 820.39,
    y: 716.8,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 840.67,
    y: 723.83,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 840.67,
    y: 716.81,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 826.63,
    y: 730.81,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 833.66,
    y: 730.81,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 826.65,
    y: 709.82,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 833.69,
    y: 709.82,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.74,
    height: 15.97,
    x: 740.9,
    y: 688.71,
    className: "carSharing_after_svg__cls-36",
    rx: 6.82
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-37",
    transform: "matrix(1.04 0 0 1 751.47 702.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "carSharing_after_svg__cls-38"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.5,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.59,
    y: 0,
    className: "carSharing_after_svg__cls-39"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.14,
    y: 0
  }, "k mich "), /*#__PURE__*/React.createElement("tspan", {
    x: 71.9,
    y: 0,
    className: "carSharing_after_svg__cls-40"
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.09,
    y: 0
  }, "o du willst"))), /*#__PURE__*/React.createElement("path", {
    d: "M52.53 629.14l30.58-14.78-25.48-24c-.54.26-37.08-7-37.62-6.77a25.8 25.8 0 00-3.62 2.14l-90.63-2.14-9.3 3.36c-.71-.34-2.12 2.15-2.83 1.81-.54-.26-.37 2.61-.91 2.35l-27.85 26.21 31.92 16.09c7.75-11.26 17.58-19 39.32-17.08H.57c23.87.29 43.03 5.74 51.96 12.81z",
    className: "carSharing_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.48 614.85h-53c-29.52 0-53.45 16.84-53.45 37.61l-26.78 4.69H94.79l-29.87-4.69c0-20.77-23.92-37.61-53.44-37.61zm47.39 36.81H-88.76v-.72c0-18.4 21.2-33.32 47.34-33.32h52.94c26.15 0 47.35 14.92 47.35 33.32z",
    className: "carSharing_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 92.41,
    y: 793.91,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.44 654.16c2.3-4.11 5.71-6.07 8.6-7.69 0 0 9.42-5.27 27.82-1.81a4.94 4.94 0 012.49 1.13c2.64 2.41 1.36 7.69 1.13 8.6-1.51 6.2-6.56 9.84-10.18 12.44a36.19 36.19 0 01-10.63 5.17c-3 .89-5.7 1.7-9.28 1.35-2.26-.22-8-.78-10.86-5.2-3.62-5.56.27-12.84.91-13.99z",
    className: "carSharing_after_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 665.28c0-3.76-53.77-6.8-120.09-6.8s-120.08 3-120.08 6.8l-49.44 31.42 338.85-2.77z",
    className: "carSharing_after_svg__cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.81 695.18c-12.59-8.94-84.75-15.79-171.89-15.79-92 0-167.32 7.64-173.42 17.31a18.12 18.12 0 00-8 15.07v46.32h.06c2.38 9 83 16.22 182 16.22s179.62-7.22 182-16.22h.05v-46.32a18.16 18.16 0 00-10.8-16.59z",
    className: "carSharing_after_svg__cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66 758.6a7.94 7.94 0 00-3.07-6.26v5.75h-.05c-2.39 9-83 16.22-182 16.22s-179.63-7.22-182-16.22h-.06v-5.72a8 8 0 00-3 6.23v27.83a7.83 7.83 0 00.24 1.89 2.38 2.38 0 00-.24 1c0 10.95 82.88 19.83 185.12 19.83s185.11-8.88 185.11-19.83a2.38 2.38 0 00-.24-1 7.83 7.83 0 00.24-1.89z",
    className: "carSharing_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: -33.79,
    y: 617.43,
    className: "carSharing_after_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-129.6 659.87 97.58 660.66 91.72 624.76 68.49 599.6 49.28 586.7 4.64 583.38 -82.28 587.88 -104.58 602.99 -123.89 630.61 -129.6 659.87",
    className: "carSharing_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.55 579.93h-78.19a78.91 78.91 0 00-78.9 78.9V664h236v-5.14a78.9 78.9 0 00-78.91-78.93zm70 77.22h-217.97v-1.51a69.89 69.89 0 0169.89-69.89h78.16a69.9 69.9 0 0169.89 69.89z",
    className: "carSharing_after_svg__cls-42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 116.42,
    y: 703.27,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: -67.08,
    y: 737.01,
    className: "carSharing_after_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.81 635.67l30.58-14.78-25.48-24c-.54.26-37.08-7-37.62-6.77a24.51 24.51 0 00-3.62 2.14l-90.67-2.13-9.3 3.36c-.71-.34-2.12 2.16-2.83 1.81-.54-.25-.37 2.61-.9 2.35l-27.86 26.21 31.92 16.1c7.75-11.26 17.58-19 39.32-17.08h44.46c23.91.26 43.07 5.72 52 12.79z",
    className: "carSharing_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.76 621.37h-53c-29.52 0-53.44 16.84-53.44 37.62l-26.79 4.69h216.51L1332.2 659c0-20.79-23.93-37.63-53.44-37.63zm47.39 36.82h-147.63v-.72c0-18.4 21.2-33.32 47.34-33.32h52.94c26.15 0 47.35 14.92 47.35 33.32z",
    className: "carSharing_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.99,
    height: 21.06,
    x: 1209.3,
    y: 649.99,
    className: "carSharing_after_svg__cls-27",
    transform: "rotate(-29.97 1211.525 660.572)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 3.99,
    x: 1218.23,
    y: 658.53,
    className: "carSharing_after_svg__cls-27",
    transform: "rotate(-60.02 1228.795 660.516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.61 703.77a30.14 30.14 0 1130.14-30.14 30.17 30.17 0 01-30.14 30.14zm0-54.3a24.16 24.16 0 1024.16 24.16 24.18 24.18 0 00-24.16-24.16z",
    className: "carSharing_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 1092.44,
    y: 800.43,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1138.71 658.74c-2.3-4.11-5.71-6.08-8.6-7.69 0 0-9.42-5.27-27.82-1.81a4.86 4.86 0 00-2.49 1.13c-2.64 2.41-1.36 7.69-1.13 8.6 1.51 6.2 6.56 9.83 10.18 12.44a36 36 0 0010.63 5.2c3 .89 5.7 1.71 9.28 1.36 2.26-.22 8-.78 10.86-5.2 3.62-5.6-.27-12.88-.91-14.03z",
    className: "carSharing_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.68 671.8c0-3.75-53.77-6.8-120.09-6.8s-120.08 3-120.08 6.8l-46.2 27 333.32.66z",
    className: "carSharing_after_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.09 701.71c-12.59-8.94-84.75-15.8-171.89-15.8-92 0-167.32 7.64-173.42 17.31a18.14 18.14 0 00-8 15.08v46.32h.06c2.38 9 83 16.22 182 16.22s179.62-7.23 182-16.22V718.3a18.15 18.15 0 00-10.75-16.59z",
    className: "carSharing_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1250.76,
    x2: 1250.75,
    y1: 616,
    y2: 628.55,
    className: "carSharing_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.94 765.13a8 8 0 00-3.07-6.27v5.76c-2.39 9-83 16.22-182 16.22s-179.63-7.23-182-16.22h-.06v-5.73a8 8 0 00-3 6.24V793a7.89 7.89 0 00.24 1.89 2.3 2.3 0 00-.24 1c0 10.95 82.88 19.83 185.12 19.83s185.11-8.88 185.11-19.83a2.3 2.3 0 00-.24-1 7.89 7.89 0 00.24-1.89z",
    className: "carSharing_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: 1233.49,
    y: 623.95,
    className: "carSharing_after_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1140.63 665.91 1368.23 669.26 1361.95 630.8 1338.72 605.64 1319.51 592.74 1274.87 589.42 1187.95 593.92 1165.65 609.02 1146.34 636.65 1140.63 665.91",
    className: "carSharing_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.84 586.46h-78.19a78.9 78.9 0 00-78.91 78.9v5.13h236v-5.13a78.9 78.9 0 00-78.9-78.9zm70 77.22h-217.98v-1.51a69.89 69.89 0 0169.89-69.89h78.16a69.89 69.89 0 0169.89 69.89z",
    className: "carSharing_after_svg__cls-44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 1077.18,
    y: 710.11,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: 1202.29,
    y: 743.53,
    className: "carSharing_after_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Mann"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f2e38",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M672.7 881.67c-1.37 1.7-1.94 1.12-2.1 8-.11 5-6.37 11.08-6.12 14.1h64.84a8.53 8.53 0 000-3.65c-1.37-5.77-9.52-8-14.17-9.22-5.21-1.41-5.77-.54-9.08-2.15-4.62-2.23-5-4.65-8.9-7.07-2.83-1.79-4-1.35-14.71-2.36-12.39-1.21-7.87.01-9.76 2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e4354",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M669.29 883.8c-1.38 1.44-4.66 8.14-4.81 13.94a93.64 93.64 0 000 10.27h64.84a6.15 6.15 0 000-3.09c-1.37-4.89-9.52-6.75-14.17-7.81-5.21-1.19-5.77-.46-9.08-1.82-4.62-1.89-7.64-2-11.51-4-2.83-1.51-1.37-3.12-12.1-4-12.39-.98-11.28-5.47-13.17-3.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.08 862.71a32.87 32.87 0 01-.72 13.44c-.58 2.08-1.42 4.16-.37 5.81 1.28 2 4.5 2.12 6.18 2.18s4.25.16 5.45-1.45c1-1.36.52-3.32.36-4-.72-3.09-1-8.54.36-18.89M670.48 868.78a33 33 0 01-.73 13.44c-.58 2.08-1.42 4.15-.36 5.81 1.27 2 4.49 2.12 6.17 2.18s4.25.15 5.45-1.46c1-1.36.52-3.32.36-4-.72-3.09-1-8.53.37-18.89",
    className: "carSharing_after_svg__cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#344c60",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M699.49 738.92c.35 15.26.45 27.89.47 36.88.08 31.24.12 46.86-.57 54.86a180 180 0 00-.57 29.15c.37 5.81 1 10.57 1.43 13.72L684.19 872l-4.91-53 7.54-34.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#466584",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M658.67 718.22q.48 14.91 1.09 30 2.64 64.29 7.63 125.86l24.22-.24c-.09-.85-.22-2.11-.36-3.63-2.16-22.84-.3-39 .18-48.94.72-15.08 1.55-25.79 2.47-34.84.7-6.83 2.46-20.23 3.45-28.13 1.3-10.29 1.53-11.84 1.82-15.16a181.38 181.38 0 00.36-27.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M700.35 724.21h1.73c-.57-14.92-.52-27.11-.37-35.6.28-15.1 1-23.26-.55-37.05a124.81 124.81 0 00-4.54-22.7c-3.33-11.12-6.79-16.86-8.9-19.8a57.34 57.34 0 00-3.63-4.54c-3.06-3.39-3.86-3.32-7.44-6.9-3.77-3.75-4.33-5.27-6-5.26-2 0-3.37 2.1-5.08 4.72-6.32 9.65-9.48 14.47-10 15.62a69.37 69.37 0 00-4.91 15.62c-1.92 10.32-.38 15.3-.36 32.32 0 6.41-.2 11.59-.36 14.71l.73 47.77c.64 0 1.66.08 2.91.18a91.1 91.1 0 0111.42 1.64c4.6.91 15.12 3 23.61.9a50.26 50.26 0 0111.74-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba9079",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.17,
    d: "M667.2 586.18a5.19 5.19 0 01-2.72-.36c-2.23-1-2.92-3.68-3.45-5.27-1.56-4.67-2.87-3.5-8.18-12.53-2.5-4.27-3.76-6.4-4.54-8.72-2.81-8.36-.27-18.5 4.91-25.61 6.67-9.14 16.46-11.53 19.79-12.35 6.69-1.63 12.44-1 22.52.18a130.79 130.79 0 0113.08 2.18 20.1 20.1 0 00-4 1.46 19.22 19.22 0 00-4.72 3.27L713 529a12.39 12.39 0 010 2.36c-.57 5.95-5.35 9.72-6.18 10.35-5.3 4-8.5.86-12.53 3.82-6 4.37-.46 12.43-6.9 24.15-2.34 4.27-5.5 7-11.8 12.53-1.13.93-4.28 3.62-8.39 3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.92 584.36a85.88 85.88 0 008.64 4.52l.44.21c4.07 1.83 7.73 3.2 11.62 2.54a5.28 5.28 0 002.36-1.09 9.23 9.23 0 003.27-4.54 24.63 24.63 0 001.11-11.9c0-.07-.17-.46 0-.64a.5.5 0 01.42-.09 7.31 7.31 0 003-.2 2.25 2.25 0 001.16-1 2.48 2.48 0 00.06-1.71 5.65 5.65 0 00-1.08-2.18 8.8 8.8 0 01-1.2-1.85 3.14 3.14 0 00-.13-.43c-.08-.25-.16-.43-.17-.46a13.16 13.16 0 01-.53-2 22.2 22.2 0 01-.45-4.27 19.83 19.83 0 01.73-4.09 21.19 21.19 0 00.45-8.08 8.27 8.27 0 00-7.35-7.72c-.93-.2-5.87-1.15-8.9 1.82a9.14 9.14 0 00-2 3.63c-1.9 4.83-.85 6.25-2.36 10-1.08 2.66-3.38 6.34-6 6.36a2.81 2.81 0 01-1.81-.55c-.83-.67-.67-1.56-1.64-3.81a4.55 4.55 0 00-.9-1.64 3.91 3.91 0 00-4.36 0c-1.33.86-1.68 2.3-2 3.64a13 13 0 00.36 6.9c.72 2.26 1.51 2.79 1.82 5.08a12.23 12.23 0 010 3.09c-.47 4-2.17 7.93-3.27 10.72-2.6 6.57-4.14 10.6-2.36 12.71.37.45.61.46 2.22 1.22 4.34 2.06 4.58 2.87 8.58 4.91 1.49.75 7.24 3.68 8 2.59.23-.32-.06-.82-.41-1.64a22.13 22.13 0 01-1.5-6.67c-.5-4.15.61-7.22 1.09-7.22.1 0 3.17.37 3.48.34l1.7.09s-.7 0 1.27-.06",
    className: "carSharing_after_svg__cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.44,
    d: "M697.88 554.87a4.3 4.3 0 012.39-1.49 4.48 4.48 0 013.59.89"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 700.87,
    cy: 560.25,
    className: "carSharing_after_svg__cls-35",
    rx: 2.99,
    ry: 2.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.39,
    cy: 560.89,
    className: "carSharing_after_svg__cls-3",
    rx: 1.05,
    ry: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.81 578.73a14 14 0 002.18 1.46 14.78 14.78 0 006.9 1.72M674.1 559.39a3.87 3.87 0 011.37 1.36 4.54 4.54 0 01-.14 4.09",
    className: "carSharing_after_svg__cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.45 677.36a7.59 7.59 0 01-3.5.56 9.05 9.05 0 01-1.16-.2c-3.2-.83-13.42-1.87-26.15-4.73q-3.14-.71-6.18-1.45s-.22-2.36-.36-3.63c-.29-2.63-.64-4.54-.73-5.09-.35-2.15-.72-7.44-.72-21.43l-17.08 1.46c.13 14.23-.12 22.94-.72 27.24a17.2 17.2 0 00.36 7.26 18.94 18.94 0 002.18 4.72c2.65 4 24.61 7.46 54.85 7.63.24.13.61.32 1 .57 5.1 2.77 5.65 3.68 8.11 4.79 2 .89 4.67 2.09 7.56 1.2a8.33 8.33 0 003.5-2.31c3.75-3.81 3.83-9.27 3.78-11.06",
    className: "carSharing_after_svg__cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707484",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.74,
    d: "M721.56 679.3l8.18 9.85a3.26 3.26 0 004.37.51l21.76-15.83a2.79 2.79 0 00.55-4.09l-8.18-9.84a3.27 3.27 0 00-4.37-.52l-21.76 15.83a2.79 2.79 0 00-.55 4.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    d: "M727 676.73l6.73 8.1a2.5 2.5 0 003.36.4l15.71-11.43a2.15 2.15 0 00.42-3.14l-6.73-8.11a2.51 2.51 0 00-3.36-.39l-15.71 11.43a2.15 2.15 0 00-.42 3.14z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M742.53 664.16l2.19 2.83-2.82 2.2-2.2-2.83 2.83-2.2m.06-.48l-3.37 2.62 2.62 3.36 3.36-2.61-2.61-3.37z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 741.39,
    y: 665.84,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 742.206 666.636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.16 671.4l2.2 2.83-2.83 2.2-2.2-2.83 2.83-2.2m.06-.47l-3.37 2.61 2.62 3.37 3.36-2.62-2.61-3.36z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 747.03,
    y: 673.1,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.4 748.544 669.82)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.28 669.79l2.2 2.83-2.83 2.2-2.2-2.83 2.83-2.2m.06-.48l-3.34 2.62 2.62 3.36 3.37-2.61-2.62-3.37z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 734.14,
    y: 671.48,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 734.944 672.267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.91 677l2.2 2.83-2.83 2.2-2.2-2.83 2.83-2.2m.06-.47l-3.37 2.61 2.62 3.37 3.37-2.62-2.59-3.33z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 739.77,
    y: 678.72,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 740.58 679.513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.78 670.14l2.59 3.34-3.34 2.6-2.6-3.34 3.35-2.6m.06-.48l-3.88 3 3 3.88 3.88-3-3-3.88z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 740.58,
    y: 672.29,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 741.398 673.085)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 737.99,
    y: 674.3,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 738.796 675.092)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 743.18,
    y: 670.28,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 743.994 671.067)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 738.56,
    y: 669.7,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 739.37 670.493)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 742.6,
    y: 674.89,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 743.416 675.681)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 736.46,
    y: 669.67,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 737.264 670.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 739.07,
    y: 667.65,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 739.88 668.432)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 742.31,
    y: 677.21,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 743.116 677.994)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 744.92,
    y: 675.18,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 745.733 675.966)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 735.67,
    y: 674.01,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.4 737.2 670.762)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.65,
    height: 1.65,
    x: 737.69,
    y: 676.62,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 738.512 677.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 743.47,
    y: 667.95,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 744.279 668.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.66,
    height: 1.66,
    x: 745.5,
    y: 670.57,
    className: "carSharing_after_svg__cls-35",
    transform: "rotate(52.15 746.317 671.362)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 728.29,
    cy: 681.94,
    r: 1.37,
    fill: "#464655",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.14,
    height: 1.02,
    x: 750.02,
    y: 663.93,
    className: "carSharing_after_svg__cls-59",
    rx: 0.51,
    transform: "rotate(-127.85 752.107 664.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.09,
    cy: 666.93,
    r: 0.52,
    className: "carSharing_after_svg__cls-59"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "731.99 677.17 729.75 674.54 732.65 672.37",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "740.13 681.15 737.25 683.31 734.99 680.66",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "750.21 669.26 752.48 671.9 749.56 674.09",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "742.06 665.32 744.97 663.13 747.21 665.74",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "738.68 674.36 737.93 673.48 738.9 672.76",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "741.4 675.69 740.44 676.41 739.68 675.53",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "744.77 671.72 745.52 672.61 744.55 673.33",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "742.04 670.41 743.02 669.68 743.76 670.55",
    className: "carSharing_after_svg__cls-60"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 748.66,
    cy: 667.56,
    fill: "#fe0000",
    rx: 0.55,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5166",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.17,
    d: "M659.22 630.13q.22 6.18.9 12.9.33 3.15.73 6.17l20.34-1 5.81-.28 5.45-.54v-5.27c-.08-8.17-.54-16-1.27-23.43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "carSharing_after_svg__Auto-2",
    "data-name": "Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.18 637.31l30.59-14.78-25.48-24c-.54.25-37.09-7-37.62-6.77a24.33 24.33 0 00-3.62 2.13l-90.63-2.14-9.3 3.36c-.71-.34-2.13 2.16-2.84 1.81-.53-.26-.36 2.61-.9 2.35l-27.86 26.23 31.92 16.1c7.75-11.27 17.59-19 39.32-17.08h44.47c23.86.26 43.02 5.72 51.95 12.79z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.13 623h-53c-29.52 0-53.45 16.84-53.45 37.62l-26.79 4.68h216.56l-29.87-4.68c0-20.77-23.93-37.62-53.45-37.62zm47.39 36.82H338.89v-.72c0-18.41 21.2-33.32 47.35-33.32h52.94c26.15 0 47.34 14.91 47.34 33.32z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.99,
    height: 21.06,
    x: 369.68,
    y: 651.63,
    className: "carSharing_after_svg__cls-27",
    transform: "matrix(.87 -.5 .5 .87 -281.11 274.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.06,
    height: 3.99,
    x: 378.6,
    y: 660.16,
    className: "carSharing_after_svg__cls-27",
    transform: "rotate(-60.02 389.144 662.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 705.41a30.14 30.14 0 1130.14-30.14A30.18 30.18 0 01381 705.41zm0-54.3a24.16 24.16 0 1024.16 24.16A24.18 24.18 0 00381 651.11z",
    className: "carSharing_after_svg__cls-27"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 252.82,
    y: 802.07,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.58,
    height: 40.94,
    x: 520.06,
    y: 802.07,
    className: "carSharing_after_svg__cls-28",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.08 660.38c-2.3-4.11-5.7-6.08-8.59-7.69 0 0-9.43-5.27-27.83-1.81a4.86 4.86 0 00-2.49 1.13c-2.64 2.41-1.35 7.69-1.13 8.6 1.51 6.2 6.56 9.83 10.18 12.44a36.13 36.13 0 0010.63 5.2c3 .89 5.7 1.71 9.28 1.36 2.26-.22 8-.78 10.86-5.2 3.63-5.6-.26-12.88-.91-14.03zM528.1 662.33c2.3-4.12 5.7-6.08 8.59-7.7 0 0 9.43-5.27 27.83-1.81A4.89 4.89 0 01567 654c2.64 2.4 1.35 7.68 1.13 8.59-1.51 6.21-6.56 9.84-10.18 12.45a36.13 36.13 0 01-10.63 5.2c-3 .89-5.7 1.71-9.28 1.36-2.26-.22-8-.79-10.86-5.21-3.62-5.63.27-12.91.92-14.06z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.05 673.44c0-3.75-53.76-6.8-120.08-6.8s-120.09 3.05-120.09 6.8l-46.2 27 333.33.66z",
    className: "carSharing_after_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.46 703.34c-12.58-8.94-84.74-15.79-171.88-15.79-92 0-167.32 7.64-173.43 17.31a18.16 18.16 0 00-8 15.08v46.32h.06c2.38 9 82.95 16.22 182 16.22s179.63-7.23 182-16.22h.06v-46.32a18.16 18.16 0 00-10.81-16.6z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 411.14,
    x2: 411.13,
    y1: 617.64,
    y2: 630.19,
    className: "carSharing_after_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.32 766.77a8 8 0 00-3.07-6.27v5.76h-.06c-2.38 9-83 16.22-182 16.22s-179.62-7.23-182-16.22h-.06v-5.73a8 8 0 00-3 6.24v27.83a7.89 7.89 0 00.24 1.89 2.3 2.3 0 00-.24 1c0 11 82.88 19.83 185.11 19.83s185.12-8.88 185.12-19.83a2.3 2.3 0 00-.24-1 7.89 7.89 0 00.24-1.89z",
    className: "carSharing_after_svg__cls-31"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.52,
    height: 9.19,
    x: 393.87,
    y: 625.59,
    className: "carSharing_after_svg__cls-27",
    rx: 3.38
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.84 666.75 525.45 670.11 519.16 631.64 495.94 606.48 476.72 593.58 432.08 590.26 345.17 594.76 322.87 609.87 303.55 637.49 297.84 666.75",
    className: "carSharing_after_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.21 588.1H375a78.89 78.89 0 00-78.9 78.9v5.13h236V667a78.89 78.89 0 00-78.89-78.9zm70 77.21H305.24v-1.51a69.9 69.9 0 0169.89-69.89h78.15a69.9 69.9 0 0169.89 69.89z",
    className: "carSharing_after_svg__cls-29"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 237.55,
    y: 711.75,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.55,
    height: 24.57,
    x: 544.07,
    y: 711.43,
    className: "carSharing_after_svg__cls-33",
    rx: 7.97
  }), /*#__PURE__*/React.createElement("rect", {
    width: 104.27,
    height: 25.49,
    x: 361.44,
    y: 745.17,
    className: "carSharing_after_svg__cls-34",
    rx: 9.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76 714.12v7.62h-7.61v-7.62h7.61m.73-.72h-9.07v9.06h9.07v-9.06z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 401.2,
    y: 716.16,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27 714.12v7.62h-7.62v-7.62h7.62m.72-.72h-9.06v9.06H427v-9.06z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 420.75,
    y: 716.16,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76 733.63v7.62h-7.61v-7.62h7.61m.73-.72h-9.07V742h9.07v-9.06z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 401.2,
    y: 735.68,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27 733.63v7.62h-7.62v-7.62h7.62m.72-.72h-9.06V742H427v-9.06z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 420.71,
    y: 735.68,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.21 723.19v9h-9v-9h9m.72-.73h-10.44v10.45h10.44v-10.45z",
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 410.98,
    y: 725.93,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 410.96,
    y: 732.91,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 410.98,
    y: 718.94,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 403.98,
    y: 725.94,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 417.96,
    y: 725.93,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 401.2,
    y: 729.44,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 401.2,
    y: 722.41,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 421.48,
    y: 729.44,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 421.48,
    y: 722.42,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 407.44,
    y: 736.42,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.51,
    height: 3.51,
    x: 414.47,
    y: 736.42,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 407.46,
    y: 715.42,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.52,
    height: 3.52,
    x: 414.5,
    y: 715.42,
    className: "carSharing_after_svg__cls-35"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.74,
    height: 15.97,
    x: 321.71,
    y: 694.32,
    className: "carSharing_after_svg__cls-36",
    rx: 6.82
  }), /*#__PURE__*/React.createElement("text", {
    className: "carSharing_after_svg__cls-37",
    transform: "matrix(1.04 0 0 1 332.28 707.93)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "carSharing_after_svg__cls-38"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.5,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.59,
    y: 0,
    className: "carSharing_after_svg__cls-39"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.14,
    y: 0
  }, "k mich "), /*#__PURE__*/React.createElement("tspan", {
    x: 71.9,
    y: 0,
    className: "carSharing_after_svg__cls-40"
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.09,
    y: 0
  }, "o du willst"))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarSharingafter);
export default __webpack_public_path__ + "static/media/carSharing.after.01f31b5a.svg";
export { ForwardRef as ReactComponent };